module.exports = __webpack_public_path__ + "static/media/headerM.8bae8fb9.png";